import { Canceler } from "axios";
import { EntityApi } from "../../services/ApiPlatform";
import { FinalResponse, ListResponse } from "../../services/ApiPlatform/models";
import { PrimitiveObject } from "../../services/ApiPlatform/types";

export abstract class DonationTransactionApi extends EntityApi {
    protected static GET_COLLECTION = "/api/donation-transactions";

    protected static POST_COLLECTION = "/api/donation-transactions";

    protected static GET_ITEM = "/api/donation-transactions/{id}";

    protected static PUT_ITEM = "/api/donation-transactions/{id}";

    protected static PATCH_ITEM = "/api/donation-transactions/{id}";

    protected static DELETE_ITEM = "/api/donation-transactions/{id}";

    protected static GET_COLLECTION_MY = "/api/donation-transactions/my";

    protected static GET_ITEM_DOWNLOAD_RECEIPT =
        "/api/donation-transactions/{id}/download-receipt";

    protected static GET_ITEM_CANCEL_SUBSCRIPTION =
        "/api/donation-transactions/{id}/cancel-subscription";

    public static async getCollectionMy<R>(
        page = 1,
        extraParams = {},
        cancelToken?: (c: Canceler) => void
    ): Promise<FinalResponse<ListResponse<R> | null>> {
        extraParams = { ...extraParams, PATH: this.GET_COLLECTION_MY };
        return this.getCollection(page, extraParams, cancelToken);
    }

    public static async getItemDownloadReceipt<R>(
        id: number | string,
        extraParams: PrimitiveObject = {}
    ): Promise<FinalResponse<R | null>> {
        return this.getRequest(
            this.routeToPath(this.GET_ITEM_DOWNLOAD_RECEIPT, { id }),
            extraParams,
            undefined,
            {
                responseType: "blob",
            }
        );
    }

    public static async getItemCancelSubscription<R>(
        id: number | string,
        extraParams = {}
    ): Promise<FinalResponse<ListResponse<R> | null>> {
        extraParams = {
            ...extraParams,
            PATH: this.routeToPath(this.GET_ITEM_CANCEL_SUBSCRIPTION, { id }),
        };
        return this.getItem(id, extraParams);
    }
}
